module.exports = __webpack_public_path__ + "static/media/picture.86a7e082.svg";